
import { Component } from "vue-property-decorator";
import BaseView from "./baseView";
import Vue from "vue";
import AwesomePhonenumber from "awesome-phonenumber";

@Component({
    components: {}
})
export default class Signature extends BaseView {
    public name = "";
    public role = "";
    public phone = "";
    public mail = "";

    public mounted() {
        console.info("Signature");
    }

    displayPhone(phone: string): string {
        return new AwesomePhonenumber(phone, "SE").getNumber("national");
    }

    selectRole(role: string): void {
        this.role = role;
    }

    copyToClipboard(): void {
        const test = this.$refs.signature as HTMLTableElement;
        const el = document.createElement("textarea");
        el.value = test.innerHTML;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        Vue.$toast.open({ position: "top", message: "Copied to clipboard" });
    }
}
